module.exports = __webpack_public_path__ + "img/img24.2750bc3e.svg";